import { render } from "./VacancyDetailView.vue?vue&type=template&id=0b7b6262"
import script from "./VacancyDetailView.vue?vue&type=script&lang=js"
export * from "./VacancyDetailView.vue?vue&type=script&lang=js"

import "./VacancyDetailView.vue?vue&type=style&index=0&id=0b7b6262&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__